// Home.jsx

import React, { useState, useEffect, useRef } from "react";

import HeroSlider from "../common/homeslider";
import OfferPopup from "./OfferPopup";
import StepsFlow from "../common/stepsflow";
import TestimonialsSection from "../common/testimonials-section";
import Dsa from "../layout/Dsa";

import StatsSection from "./home/StatsSection";
import ProductsSection from "./home/ProductsSection";
import BankingPartnersSection from "./home/BankingPartnersSection";
import InsuranceSection from "./home/InsuranceSection";
import DSASection from "./home/DSASection";
import TeamSection from "./home/TeamSection";
import ToastNotifications from "./home/ToastNotifications";

// ✅ Rupee Animation
import { initRupeeAnimation } from "./rupeeAnimation";

import "./Home.css";

const Home = () => {
  const [isDSAFormOpen, setIsDSAFormOpen] = useState(false);

  // ✅ Hero Animation Container Ref
  const heroAnimationRef = useRef(null);

  // =========================
  // DSA FORM
  // =========================

  const openDSAForm = () => {
    setIsDSAFormOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeDSAForm = () => {
    setIsDSAFormOpen(false);
    document.body.style.overflow = "auto";
  };

  // =========================
  // RUPEE ANIMATION
  // =========================

  useEffect(() => {
    if (!heroAnimationRef.current) return;

    // Delay for smoother first paint
    const timer = setTimeout(() => {
      const cleanupAnimation = initRupeeAnimation(heroAnimationRef.current);

      // Store cleanup
      heroAnimationRef.current.cleanupAnimation = cleanupAnimation;
    }, 300);

    return () => {
      clearTimeout(timer);

      // Cleanup animation safely
      if (
        heroAnimationRef.current &&
        heroAnimationRef.current.cleanupAnimation
      ) {
        heroAnimationRef.current.cleanupAnimation();
      }

      // Restore body scroll
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <>
      {/* <ToastNotifications /> */}

      {/* =========================
          HERO SECTION + ANIMATION
      ========================== */}

      <section ref={heroAnimationRef} className="hero-animation-wrapper">
        <HeroSlider />
      </section>

      {/* =========================
          OTHER SECTIONS
      ========================== */}

      <OfferPopup />

      <StatsSection />

      <ProductsSection />

      <section className="process-section">
        <StepsFlow />
      </section>

      <BankingPartnersSection />

      <InsuranceSection />

      <DSASection onOpenDSAForm={openDSAForm} />

      <TeamSection />

      <TestimonialsSection
        title="What Our Customers Say"
        subtitle="Hear From Our Satisfied Clients About Their Experience With Krishna Finconcept Services"
      />

      {/* =========================
          DSA MODAL
      ========================== */}

      <Dsa isOpen={isDSAFormOpen} onClose={closeDSAForm} />
    </>
  );
};

export default Home;
